import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/views/privacy-policy/index.js");
